import React from 'react';
import styled from '@emotion/styled';

const LoadingStyle = styled.div`
  comment: LoadingStyle;
  display: inline-block;
  font-family: monospace;
  clip-path: inset(0 3ch 0 0);
  animation: l 1s steps(4) infinite;
`;

interface Props {
  error?: boolean;
}
export const Loading = (props: Props) => {
  if (props.error) {
    return <div>Error!</div>;
  } else {
    return <LoadingStyle>Loading...</LoadingStyle>;
  }
};

export default Loading;
